module.exports = __webpack_public_path__ + "img/FI01169318.7c092d15.png";